import { useState } from 'react';
import { buildWaLink } from '../api/getProducts';

const FAQS = [
  {
    q: 'How do I order a product?',
    a: 'Tap "Order on WhatsApp" on any product card. It opens a WhatsApp message already filled in with the product name and price, sent straight to our line — no forms, no account needed.',
  },
  {
    q: 'What payment methods do you accept?',
    a: 'MTN MoMo, Airtel Money, and cash on delivery within Kampala. For upcountry orders we confirm payment before dispatch.',
  },
  {
    q: 'Do you deliver outside Kampala?',
    a: 'Yes. We deliver countrywide — delivery fees and timelines are arranged directly on WhatsApp once we know your location.',
  },
  {
    q: 'Are your phones and laptops genuine?',
    a: 'All stock comes from verified suppliers. UK-used items are graded for condition and battery health before listing, and phones/laptops come with a warranty.',
  },
  {
    q: 'Can I return or exchange an item?',
    a: 'Yes, within 48 hours of delivery if the item is faulty or not as described. Message us on WhatsApp with your order details to start a return.',
  },
  {
    q: "What if I can't find what I'm looking for?",
    a: "We source on request. Message us the gadget you need and we'll check availability and price for you.",
  },
];

export function FAQ() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="mx-auto max-w-3xl px-4 py-20 sm:px-8">
      <div className="mb-10 text-center">
        <div className="mb-3 text-xs font-extrabold uppercase tracking-[0.2em] text-accent">
          Good to know
        </div>
        <h2 className="text-[clamp(1.8rem,4vw,2.5rem)] font-black tracking-tight">
          Frequently asked questions
        </h2>
      </div>

      <div className="flex flex-col gap-3">
        {FAQS.map((item, i) => {
          const open = openIndex === i;
          return (
            <div
              key={item.q}
              className="overflow-hidden rounded-2xl border border-white/10 bg-card"
            >
              <button
                type="button"
                onClick={() => setOpenIndex(open ? -1 : i)}
                aria-expanded={open}
                className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
              >
                <span className="text-sm font-bold sm:text-base">{item.q}</span>
                <span
                  className={`shrink-0 text-xl font-light text-accent transition-transform ${
                    open ? 'rotate-45' : ''
                  }`}
                >
                  +
                </span>
              </button>
              <div
                className={`grid transition-all duration-200 ${
                  open ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'
                }`}
              >
                <div className="overflow-hidden">
                  <p className="px-5 pb-4 text-sm leading-relaxed text-text-muted">{item.a}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <p className="mt-8 text-center text-sm text-text-muted">
        Still have a question?{' '}
        <a
          href={buildWaLink('Hi Chikwafu, I have a question')}
          target="_blank"
          rel="noopener noreferrer"
          className="font-bold text-accent hover:underline"
        >
          Ask us on WhatsApp
        </a>
      </p>
    </section>
  );
}
